import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { addIcons } from 'ionicons';
import { add, close, remove } from 'ionicons/icons';
import { AuthService } from '../../core/auth.service';
import { globals } from '../../../environments/globals';

// Import specific Ionic components
import { IonList, IonListHeader, IonLabel, IonIcon, IonItem, IonSelect, 
         IonSelectOption, IonCheckbox, IonRadioGroup, IonRadio } from '@ionic/angular/standalone';

@Component({
    selector: 'search-classifications',
    styleUrls: ['./search-classifications.scss'],
    templateUrl: './search-classifications.html',
    standalone: true,
    host: { ngSkipHydration: 'true' },
    imports: [
        CommonModule, 
        FormsModule, 
        IonList, 
        IonListHeader, 
        IonLabel, 
        IonIcon, 
        IonItem, 
        IonSelect, 
        IonSelectOption, 
        IonCheckbox,
        IonRadioGroup,
        IonRadio
    ]
})
export class SearchClassifications implements AfterViewInit, OnInit {
  groupingList           : any[] = globals.groupings;
  countryList            : any[] = globals.countries;
  classificationsList    : any = globals.classifications;
  directoryData          : any = globals.directory;
  regionsList            : any = globals.regions;
  typesList              : any = globals.types;
  salaryList             : any = globals.salary;
  ratesList              : any = globals.rates;

  groupings              = this.groupingList.sort((a, b) => a > b ? 1 : -1);
  countries              = this.countryList;
  regions                = this.regionsList;
  types                  = this.typesList;
  salaries               = this.salaryList;
  rates                  = this.ratesList;

  classifications        : any;
  searchGrouping         : any;
  searchClass            : any;
  searchMethodChild      : any;
  searchLocation         : any;
  searchCountry          : any;
  searchRegion           : any;
  searchType             : any;
  searchSalary           : any;
  searchRate             : any;
  filters                : any;
  type                   : any;
  salary                 : any;
  rate                   : any;
  user                   : any;

  byGrouping             : boolean = false;
  byClassification       : boolean = true;
  byLocation             : boolean = false;
  byCountry              : boolean = false;
  byType                 : boolean = false;
  currentFilters         : boolean = true;

  @Input() service       : string = '';
  @Input() group         : string = '';
  @Input() class         : string = '';

  @Output() searchOutput = new EventEmitter<string>();
  @Output() clearOutput  = new EventEmitter<string>();

  constructor(
    private auth: AuthService,
  ) {
    this.filters = {
      group: '',
      class: '',
      location: '',
      name: '',
      country: '',
      region: '',
      rate: [],
      salary: [],
      type: ''
    }
    addIcons({ 
      add, 
      close, 
      remove 
    });
  }

  ngOnInit() {
    for (let key in this.classificationsList) {
      let value = this.classificationsList[key]
      this.classificationsList[key] = value.sort((a: number, b: number) => a > b ? 1 : -1)
    }
    this.auth.user.subscribe(data => {
      if (data) {
        this.user = data;
      }
      // if (this.user) {
      //   this.setPreferences();
      // }
    })

    if (this.group) {
      this.classifications  = this.classificationsList[this.group]
      this.searchGrouping   = this.group;
      this.filters.group    = this.group;
      this.byGrouping       = true;
      this.filterGroup();
    }
    if (this.class) {
      this.classifications  = this.classificationsList[this.group]
      this.searchGrouping   = this.group;
      this.filters.group    = this.group;
      this.byGrouping       = true;
      if (this.classifications && this.byGrouping) {
        this.searchClass    = this.class;
        this.filters.class  = this.class;
        if (this.searchClass && this.filters.class) {
          this.filterClass();
        }
      }
    }
  }

  ngAfterViewInit() {
    // if (this.user) {
    //   this.setPreferences();
    // }
  }

  async setPreferences() {
    if (this.user.country) {
      this.regions          = this.regionsList[this.user.country];
      this.searchCountry    = this.user.country;
      this.filters.country  = this.user.country;
      this.byCountry        = true;
      if (this.user.region && this.regions && this.byCountry) {
        this.searchRegion   = this.user.region;
        this.filters.region = this.user.region;
        if (this.searchRegion && this.filters.region) {
          await this.filterRegion();
        }
      }
    }
    if (this.user.grouping) {
      this.classifications  = this.classificationsList[this.user.grouping]
      this.searchGrouping   = this.user.grouping;
      this.filters.group    = this.user.grouping;
      this.byGrouping       = true;
      if (this.user.classification && this.classifications && this.byGrouping) {
        this.searchClass    = this.user.classification;
        this.filters.class  = this.user.classification;
        if (this.searchClass && this.filters.class) {
          await this.filterClass();
        }
      }
    }
  }

  resetFilters() {
    this.searchGrouping     = ''
    this.searchClass        = ''
    this.searchLocation     = ''
    this.searchCountry      = ''
    this.searchRegion       = true
    this.searchType         = ''
    this.searchSalary       = null
    this.searchRate         = null
    this.filters = {
      group: '',
      class: '',
      location: '',
      country: '',
      region: '',
      rate: [],
      salary: [],
      type: ''
    }
    this.clearOutput.emit(this.filters)
  }

  arrayRemove(arr: any[], value: any) {
    return arr.filter(function(ele: any){
      return ele != value;
    });
  }

  removeGroup() {
    this.searchGrouping     = ''
    this.searchClass        = ''
    this.filters.group      = ''
    this.filters.class      = ''

    this.searchOutput.emit(this.filters)
  }

  removeClass() {
    this.filters.group      = this.searchGrouping

    this.searchClass        = ''
    this.filters.class      = ''

    this.searchOutput.emit(this.filters)
  }

  removeLocation() {
    this.searchLocation     = ''
    this.searchCountry      = ''
    this.searchRegion       = ''
    this.filters.country    = ''
    this.filters.region     = ''
    this.filters.location   = ''

    this.searchOutput.emit(this.filters)
  }

  removeCountry() {
    this.searchCountry      = ''
    this.searchRegion       = ''
    this.filters.name       = ''
    this.filters.country    = ''
    this.filters.region     = ''

    this.searchOutput.emit(this.filters)
  }

  removeRegion() {
    this.filters.country    = this.searchCountry
    this.searchRegion       = ''
    this.filters.region     = ''

    this.searchOutput.emit(this.filters)
  }

  removeType() {
    this.searchType         = ''
    this.searchSalary       = null
    this.searchRate         = null
    this.filters.type       = ''
    this.filters.salary     = []
    this.filters.rate       = []

    this.searchOutput.emit(this.filters)
  }

  removeSalary(salary: any) {
    this.filters.type       = this.searchType
    this.searchSalary       = this.arrayRemove(this.searchSalary,salary)
    this.filters.salary     = this.searchSalary

    this.searchOutput.emit(this.filters)
  }

  removeRate(rate: any) {
    this.filters.type       = this.searchType
    this.searchRate         = this.arrayRemove(this.searchRate,rate)
    this.filters.rate       = this.searchRate

    this.searchOutput.emit(this.filters)
  }

  filterGroup() {
    if (!this.byGrouping) {
      this.searchClass      = ''
      this.classifications  = this.classificationsList[this.searchGrouping]
      this.filters.group    = this.searchGrouping
      this.filters.class    = ''
    }
    this.byGrouping         = false;

    this.searchOutput.emit(this.filters)
  }

  filterLocation() {
    this.filters.location   = this.searchLocation
    if (this.searchLocation === 'remote') {
      this.searchCountry    = ''
      this.searchRegion     = ''
      this.filters.name     = ''
      this.filters.country  = ''
      this.filters.region   = ''
    }
    this.searchOutput.emit(this.filters)
  }

  async filterCountry() {
    if (!this.byCountry) {
      this.searchRegion     = ''
      this.regions          = this.regionsList[this.searchCountry]
      this.filters.name     = this.directoryData[this.searchCountry].name
      this.filters.country  = this.searchCountry
      this.filters.region   = ''
    }
    this.byCountry          = false;

    this.searchOutput.emit(this.filters)
  }

  async filterClass() {
    this.filters.class      = this.searchClass
    this.searchOutput.emit(this.filters)
  }

  async filterRegion() {
    this.filters.region     = this.searchRegion
    this.searchOutput.emit(this.filters)
  }

  async filterType() {
    this.filters.type       = this.searchType
    this.searchOutput.emit(this.filters)
  }

  async filterSalary() {
    this.filters.salary     = this.searchSalary
    this.searchOutput.emit(this.filters)
  }

  async filterRate() {
    this.filters.rate       = this.searchRate
    this.searchOutput.emit(this.filters)
  }
}